// utils/dateFormatter.js
export const getSystemFormattedTimestamp = () => {
  const now = new Date();


  const formatted =
    now.getFullYear().toString() + "-" +
    ("0" + (now.getMonth() + 1)).slice(-2) + "-" +
    ("0" + now.getDate()).slice(-2) + "_" +
    ("0" + now.getHours()).slice(-2) + "-" +
    ("0" + now.getMinutes()).slice(-2) + "-" +
    ("0" + now.getSeconds()).slice(-2);

  return formatted;
};

